import {createFileRoute, useNavigate} from '@tanstack/react-router';

import {ClientDetailPage} from '@/modules/clients/pages/ClientDetailPage';

export type ClientDetailTab = 'overview' | 'tax' | 'projects' | 'contacts';

const TAB_VALUES: ReadonlyArray<ClientDetailTab> = ['overview', 'tax', 'projects', 'contacts'];

export interface ClientDetailSearch {
  tab?: ClientDetailTab;
}

function parseTab(value: unknown): ClientDetailTab | undefined {
  return TAB_VALUES.find((t) => t === value);
}

const validateClientDetailSearch = (search: Record<string, unknown>): ClientDetailSearch => ({
  tab: parseTab(search.tab),
});

/**
 * The tab lives in `?tab=`, not in the page's state: a link to a client's
 * contacts should open on contacts, and a reload should not silently return to
 * Overview. Same shape as the advance detail route. `replace: true` keeps tab
 * switching out of the back-button history.
 */
const RouteComponent = () => {
  const {clientId} = Route.useParams();
  const {tab} = Route.useSearch();
  const navigate = useNavigate();
  return (
    <ClientDetailPage
      activeTab={tab ?? 'overview'}
      onTabChange={(next) =>
        void navigate({
          to: '/clients/$clientId',
          params: {clientId},
          search: {tab: next} satisfies ClientDetailSearch,
          replace: true,
        })
      }
    />
  );
};

export const Route = createFileRoute('/_authenticated/clients/$clientId')({
  validateSearch: validateClientDetailSearch,
  component: RouteComponent,
});
